import React from 'react'

import Dropdown from "./ReactDropdown";

export default class DropdownPPPlusReasons extends Dropdown
{		
	
	// Entry properties
	//
	// mode : 'list' - Just act like a dropdown with each role itemised
	//        'filter' - act as a drop down filter list, including an 'ALL' option
	
	static get defaultProps() 
	{
		var v = 
	    {
		      mode: 'list', 
	    	  label: 'Select a reason' ,
	    	  defaultValue: 0,
	   		  containerClassName: '',
		}

		return v;
	}
	
	constructor(props) 
	{
		super(props);
		
		this.keyCount = 1 ;

		let defaultValue = this.props.defaultValue == null ? 0 : props.defaultValue ;

		this.state = { dirty: false ,currentValue: defaultValue, items: this.getStaticdata() };
	}

	componentDidUpdate(prevProps, prevState)
	{
		// If the value changed externally
		if ( this.props.defaultValue != prevProps.defaultValue)
		{
			this.setState ( { currentValue: this.props.defaultValue}) ;
		}
	}

	getdata( )
	{
		this.setState ( { items : this.getStaticData() } ) ;
	}

	getStaticdata( )
	{
		var items = [
		{
			id: 0,
			desc: 'Please select a reason'
		},			  
		{
			id: 1,
			desc: '1 to 1 support, including TA'
		},
		{
			id: 2,
			desc: 'Resources'
		},
		{
			id: 3,
			desc: 'Behaviour'
		},
		{
			id: 4,
			desc: 'Therapeutic assessment/intervention'
		},
		{
			id: 5,
			desc: 'Group Provision'
		},
		{
			id: 6,
			desc: 'Educational visits'
		},
		{
			id: 7,
			desc: 'Study support'
		},
		{
			id: 8,
			desc: 'AP'
		},
		{
			id: 9,
			desc: 'Supporting role of DT'
		},
		{
			id: 100,
			desc: 'Other'
		},
		];

		return items ;
	}
	
	/**
	* Returns true if the input value complies with the validation rules supplied
	* 
	* @param {string} param - The value of the string to be tested.
	* @return {bool} true if the test passes.
	*/
	isValueValid( param )
	{
		if ( this.props.validation != null )
		{
			if ( this.props.validation.required == true )
			{
				if ( param == null || param == 0 || param == -1 || param == '#')
				{
					if ( this.state.items == null )
					{
						return true ;
					}
					else
					{
						if ( this.state.items.length > 0)
						{
							return false ;						
						}
						else
						{
							return true ;
						}
					}
				}
			}
			else
			{
				if ( param == null || param == 0)
				{
					// If not required, and empty, it's OK
					return true ;
				}
			}			
		}

		return true ;
	}

	handleChange(e) 
	{
		let index = e.target.selectedIndex;

		// Need to calculate the offset to read the actual Type Id from the correct place in the table
		// If it is a 'filter' then there is an extra entry in the listbox called 'ALL' which we need to account for
		
		let offset = 0 ;
		
		if ( this.props.mode == 'filter')
		{
			offset = -1 ;
		}

		if ( index >= 0 )
		{
			var itemid = this.state.items[index+offset].id;			
			var itemtext = this.state.items[index+offset].desc ;

			this.sendChangeNotification() ;

			this.setState ( {dirty: true, currentValue: itemid} ) ;
		}
		else
		{
			var itemid = 0 ;		
			var itemtext = "All" ;

			this.sendChangeNotification() ;

			this.setState ( {dirty: true, currentValue: itemid} ) ;
		}
		
		// Tell the owning function about the change	
		
		if ( this.props.onChange != null )
		{
			this.props.onChange ( e.target.value ) ;
		}
	}
	  
    getValue()
    {
    	return this.state.currentValue ;
    }

    returnOption ( row )
	{
		return React.createElement ( 'option', {key: this.keyCount++, name: row.id, value: row.id} , row.desc ) ;
	}

    optionList ()
    {
		return this.state.items.map(element =>
		{
			return this.returnOption ( element ) ;
		});
    }
    
    dropdown_select ( id )
    {
    	return React.createElement ( 'select', {key: this.keyCount++, value: this.state.currentValue, className: 'form-control', id: id , tabIndex: this.props.tabIndex, onChange: this.handleChange.bind(this)}, this.optionList() ) ;
    }
  
    render() 
    {
		if ( this.props.readOnly != 'readonly' )
		{
			return React.createElement ( 'div', {key: this.keyCount++, className: this.props.containerClassName}, this.optionDropdown('list1')) ;
		}
		else
		{
			return React.createElement ( 'div', {key: this.keyCount++}, this.readOnlyField()) ;
		}
    }
};


